import { useContext } from 'react';

import { ReportInternalContext } from './ReportInternalContext';

export const useReportInternalContex = () => {
  return useContext(ReportInternalContext);
};
